import React from 'react'
import AutoTooltip from 'components/Common/AutoTooltip'
import AutoTooltipContent from 'components/Common/AutoTooltip/AutoTooltipContent'
import { OFFER_TYPE_TOUR } from 'constants/offer'
import BodyText from 'components/Luxkit/Typography/BodyText'
import SecureWithDepositTag from './SecureWithDepositTag'
import { isTourV2OfferType } from 'lib/offerTypes'
import PaletteProvider from 'contexts/PaletteProvider'
import { useTranslation } from 'react-i18next'

interface Props {
  offerType: App.OfferType;
}

function SecureWithDepositTagAndTooltip(props: Props) {
  const { offerType } = props
  const { t } = useTranslation(['hotelOfferList'])
  const tagTooltip = offerType === OFFER_TYPE_TOUR || isTourV2OfferType(offerType) ?
    'Some departures available for you to secure with a deposit' : t('securePackageDepositTooltip', { ns: 'hotelOfferList' })

  return (
    <AutoTooltip>
      <PaletteProvider type="default">
        <SecureWithDepositTag />
      </PaletteProvider>
      <AutoTooltipContent width={204} position="below" type="dark">
        <BodyText variant="small">{tagTooltip}</BodyText>
      </AutoTooltipContent>
    </AutoTooltip>
  )
}

export default React.memo(SecureWithDepositTagAndTooltip)
